export interface CachedData<T> {
    data: T;
    timestamp: number;
}

const CACHE_EXPIRATION = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

export const isCacheValid = (timestamp: number | undefined): boolean => {
    if (!timestamp) return false;
    const now = Date.now();
    return now - timestamp < CACHE_EXPIRATION;
};

export const getCachedData = <T>(key: string): CachedData<T> | null => {
    try {
        const item = localStorage.getItem(key);
        if (!item) return null;
        
        const cached = JSON.parse(item) as CachedData<T>;
        if (!isCacheValid(cached.timestamp)) {
            localStorage.removeItem(key);
            return null;
        }
        
        return cached;
    } catch {
        return null;
    }
};

export const setCachedData = <T>(key: string, data: T): void => {
    const cacheData: CachedData<T> = {
        data,
        timestamp: Date.now(),
    };
    localStorage.setItem(key, JSON.stringify(cacheData));
};
